import React from 'react'
import './imageTextbox.css'

const imageTextbox = ({image, style, text}) => {
  return <div className='imageTextbox'>
    <img className='imageTextbox__Image' src={image} alt="" />
    <p style={style} className='homeDetails__text'>{text}</p>
  </div>
}

export default imageTextbox